import pick from 'lodash/pick';
import mapValues from 'lodash/mapValues';
import { action, makeObservable, observable } from 'mobx';

import { assignParams } from '@utils/assignParams';
import { updateAttributes } from '@utils/updateAttributes';

type NullableValues<T> = { [P in keyof T]: T[P] | null };

export abstract class MutableData<D extends object> {
    public abstract readonly mutableKeys: (keyof D)[];
    protected numbersFields = new Set<string>();

    public get isValid(): boolean {
        return true;
    }

    public serialize(): Readonly<D> {
        return pick(this as unknown as D, this.mutableKeys);
    }

    public update(params: Partial<NullableValues<D>>): void {
        updateAttributes(this as unknown as D, this.formatData(params));
    }

    protected init(data: D): void {
        const fields: any = {};

        this.mutableKeys.forEach(key => {
            fields[key] = observable;
            (this as any)[key] = undefined;
        });

        makeObservable(this, {
            ...fields,
            update: action,
        });

        assignParams<D>(this as unknown as D, this.formatData(data) as D);
    }

    private formatData(data: D | Partial<NullableValues<D>>): Partial<NullableValues<D>> | D {
        return mapValues(pick(data, this.mutableKeys), (value, key) => {
            return this.numbersFields.has(key) && !!value ? (Number(value) as any) : value;
        });
    }
}
